/**
 * Send someone to a hosted payment page (Stripe Checkout, PayPal, the Stripe
 * billing portal).
 *
 * These pages refuse to load inside an embedded frame for security reasons.
 * When the app is running inside a frame — the Lovable preview, an in-app
 * browser, an embedded webview — a plain `location.href` change leaves the
 * person staring at a blank area and it looks as though "the payment page
 * never opened". In that case we move the top-level window instead, and if
 * the frame isn't allowed to touch the top window we open a new tab.
 */
export function openPaymentPage(url: string): void {
  let framed = false;
  try {
    framed = typeof window !== "undefined" && window.top !== window.self;
  } catch {
    // Cross-origin parent: reading `window.top` threw, so we are framed.
    framed = true;
  }

  if (framed) {
    try {
      if (window.top) {
        window.top.location.href = url;
        return;
      }
    } catch {
      /* Not permitted to navigate the parent — fall through to a new tab. */
    }
    const opened = window.open(url, "_blank", "noopener,noreferrer");
    if (opened) return;
  }

  window.location.href = url;
}
